import { gql, TypedDocumentNode } from "@apollo/client";

import { SharedModule, SharedVersion } from "types/generated";

export type SharedModuleData = Pick<SharedModule, "id" | "description" | "labels" | "name" | "ownerSubdomain"> & {
  current: Pick<SharedVersion, "id" | "number" | "state" | "yanked"> | null;
  latest: Pick<SharedVersion, "id"> | null;
};

type GetSharedModulesData = {
  sharedModules: SharedModuleData[];
};

export const GET_SHARED_MODULES: TypedDocumentNode<GetSharedModulesData> = gql`
  query GetSharedModules {
    sharedModules {
      id
      description
      labels
      name
      ownerSubdomain
      current {
        id
        number
        state
        yanked
      }
      latest {
        id
      }
    }
  }
`;
